import { render, staticRenderFns } from "./SelectCompanies.vue?vue&type=template&id=483b3525"
import script from "./SelectCompanies.vue?vue&type=script&lang=js"
export * from "./SelectCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports